import { returnsCenterIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const ReturnsCenterSchema_ = z.object({
  id: returnsCenterIdFormat.schema,
  name: z.string(),
  street1: z.string().nullable(),
  street2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postalCode: z.string().nullable(),
  country: z.string().nullable(),
  hasLinkedLocation: z.boolean(),
});

export const ReturnsCenterSchema: z.ZodType<ReturnsCenter> =
  ReturnsCenterSchema_;
export interface ReturnsCenter extends z.infer<typeof ReturnsCenterSchema_> {}

export const returnsCenterSortKeys = [
  "name",
  "street1",
  "street2",
  "city",
  "state",
  "postalCode",
  "country",
] as const;

export type ReturnsCenterSortKey = (typeof returnsCenterSortKeys)[number];

const TableSortSchema_ = z
  .object({
    key: z.enum(returnsCenterSortKeys),
    direction: z.enum(["asc", "desc"]),
  })
  .nullish();

export const TableSortSchema: z.ZodType<TableSort> = TableSortSchema_;
export type TableSort = z.infer<typeof TableSortSchema_>;

export const getReturnsCenters = unaryRpc({
  name: "getReturnsCenters" as const,
  input: z.object({ sort: TableSortSchema }),
  output: z.object({ returnsCenters: z.array(ReturnsCenterSchema) }),
});
